import gql from 'graphql-tag'

// eslint-disable-next-line import/prefer-default-export
export const BaseDocumentGeneralInfo = gql`
    fragment BaseDocumentGeneralInfo on BaseDocument {
        updatedOn
    }
`
